<template>
  <form @submit.prevent="sendMessage">
    <div class="af-input">
      <label class="af-label" for="name">Kontaktperson</label>
      <input
        id="name"
        name="name"
        class="af-input__field"
        placeholder="Ange ditt namn"
        type="text"
        v-validate="'required'"
        v-model="name" />
      <div class="af-form-error" v-show="errors.has('name')">
        <icon fill="#c80b1c" type="exclamation-circle" />
        <div class="af-form-error__text">{{ errors.first('name') }}</div>
      </div>
    </div>

    <div class="af-input">
      <label class="af-label" for="email">Din mejl</label>
      <input
        id="email"
        name="email"
        class="af-input__field"
        placeholder="Ange din mejladress"
        type="text"
        v-validate="'required|email'"
        v-model="email" />
      <div class="af-form-error" v-show="errors.has('email')">
        <icon fill="#c80b1c" type="exclamation-circle" />
        <div class="af-form-error__text">{{ errors.first('email') }}</div>
      </div>
    </div>

    <div class="af-input">
      <label class="af-label" for="title">Rubrik</label>
      <input
        id="title"
        name="title"
        class="af-input__field"
        placeholder="Ange ett ämne"
        type="text"
        v-validate="'required'"
        v-model="title" />
      <div class="af-form-error" v-show="errors.has('title')">
        <icon fill="#c80b1c" type="exclamation-circle" />
        <div class="af-form-error__text">{{ errors.first('title') }}</div>
      </div>
    </div>

    <div class="af-textarea">
      <label class="af-label" for="message">Meddelande</label>
      <textarea
        id="message"
        name="message"
        class="af-textarea__field"
        placeholder="Börja gärna meddelandet med att presentera ditt företag och din roll."
        type="text"
        v-validate="'required'"
        v-model="message" />
      <div class="af-form-error" v-show="errors.has('message')">
        <icon fill="#c80b1c" type="exclamation-circle" />
        <div class="af-form-error__text">{{ errors.first('message') }}</div>
      </div>
    </div>

    <af-success-notification v-if="status === 'success'">
      Ditt meddelande har skickats!
    </af-success-notification>

    <af-error-notification v-if="status === 'error'">
      Ett fel uppstod när meddelandet skickades. Vad god försök igen.
    </af-error-notification>

    <af-button
      buttonStyle="nis-primary"
      lowercase
      size="large"
      type="submit">
      Skicka meddelande
    </af-button>
  </form>
</template>

<script>
import gql from 'graphql-tag'
import Button from '@/components/Button/Button'
import Icon from '@/components/Icon'
import AfSuccessNotification from '@/components/AfSuccessNotification'
import AfErrorNotification from '@/components/AfErrorNotification'

export default {
  name: 'message-form',
  props: {
    userId: {
      required: true,
      type: String
    }
  },
  components: {
    'af-button': Button,
    'af-error-notification': AfErrorNotification,
    'af-success-notification': AfSuccessNotification,
    Icon
  },
  data() {
    return {
      email: '',
      message: '',
      name: '',
      title: '',
      status: ''
    }
  },
  methods: {
    sendMessage () {
      this.status = ''

      this.$validator.validateAll().then(async isValid => {
        if (isValid) {
          try {
            const SEND_MESSAGE = gql`
              mutation SendMessageToUser($input: SendMessageToUserInput!) {
                sendMessageToUser(input: $input)
              }
            `

            await this.$apollo.mutate({
              mutation: SEND_MESSAGE,
              variables: {
                input: {
                  email: this.email,
                  message: this.message,
                  name: this.name,
                  title: this.title,
                  userId: parseInt(this.userId, 10)
                }
              }
            })

            this.status = 'success'
          } catch (error) {
            this.status = 'error'
          }
        }
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
.af-input {
  margin-bottom: 10px;
}

.af-input__field {
  background: none;
  border: 1px solid #999;
  border-radius: 5px;
  display: block;
  font-size: 16px;
  padding: 10px;
  width: 100%;
}

.af-label {
  color: #333;
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.af-textarea {
  margin-bottom: 5px;
}

.af-textarea__field {
  background: none;
  border: 1px solid #999;
  border-radius: 5px;
  display: block;
  font-size: 16px;
  height: 250px;
  resize: none;
  padding: 10px;
  width: 100%;
}

.af-form-error {
  align-items: center;
  display: flex;
  margin-top: 5px;
}

.af-form-error__text {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Profile/MessageForm.vue